var _style, _g;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
var SvgIconDelete = function SvgIconDelete(_ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 30 30",
    style: {
      enableBackground: "new 0 0 30 30"
    },
    xmlSpace: "preserve",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#E2E2E2;}\r\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_11_",
    className: "st0",
    d: "M21,8C21,8,21,8,21,8C21,8,21,8,21,8H9C8.5,8,8,8.5,8,9l1,15c0,0.5,0.5,1,1,1h10 c0.5,0,1-0.5,1-1l1-15C22,8.5,21.6,8,21,8z M10.1,10h9.9l-0.9,13h-8.1L10.1,10z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_12_",
    className: "st0",
    d: "M17.5,13.5h-5c-0.5,0-1,0.5-1,1s0.5,1,1,1h5c0.5,0,1-0.5,1-1S18,13.5,17.5,13.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_13_",
    className: "st0",
    d: "M17,17.5h-4c-0.5,0-1,0.5-1,1s0.5,1,1,1h4c0.5,0,1-0.5,1-1S17.5,17.5,17,17.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_14_",
    className: "st0",
    d: "M11,7h8c0.5,0,1-0.5,1-1s-0.5-1-1-1h-8c-0.5,0-1,0.5-1,1S10.5,7,11,7z"
  }))));
};
export default SvgIconDelete;